import { BaseLayout } from '~/src/components/shared/layout'
import { FestivalContextProvider } from '~/src/contexts'
import { FestivalNavigation, FestivalInfo } from '~/src/components/festival'

export default function FestivalDetail() {

  return (
    <BaseLayout>
      <FestivalContextProvider>
        <FestivalNavigation />	
        <FestivalInfo />
      </FestivalContextProvider>
    </BaseLayout>
  )
}